export * from './response';
export var AppTreeItemTypes;
(function (AppTreeItemTypes) {
    AppTreeItemTypes["BizModel"] = "BizModel";
    AppTreeItemTypes["Folder"] = "Folder";
    AppTreeItemTypes["Page"] = "Page";
})(AppTreeItemTypes || (AppTreeItemTypes = {}));
